import "./markup-menu";
import $ from 'jquery';
global.$ = global.jQuery = $;
import svg4everybody from 'svg4everybody';
import slick from 'slick-carousel';
require("@fancyapps/fancybox");
require("sticky-kit/dist/sticky-kit.js");
require('jquery-viewport-checker')

import scroll from './components/scroll';
import custom from './components/custom';
import map from "./components/map";
import mapContacts from "./components/map-contacts";
import sliders from "./components/sliders";
import Tabs from './components/tabs';
import { svg } from './components/svg';
import activeNav from "./components/active-nav";
import Select from "./components/select";
import flexMasonry from "./components/flexMasonry";

document.addEventListener("DOMContentLoaded", () => {
  if ($('.gallery__list').length) {
    global.flexMasonry = flexMasonry()
  }
  sliders();
  svg4everybody();
  map();
  mapContacts();
  svg();
  new Select();
  scroll();
  custom();
  global.customTabs = new Tabs({
    onChange() {
      $(".production__slider").each(function (index, el) {
        $(el).slick("refresh");
      });
    }
  });
  if ($(window).width() > 1200) {
    activeNav();
    $(".js-sticky").stick_in_parent({
      offset_top: 111,
      recalc_every: 1
    });
  }
});
$(window).on("load", function () {
  $(".preloader").addClass("hide");
  setTimeout(() => {
    $(".main-slider__controls").addClass("animations");
    $(".main-slider__item-title").addClass("animations");
    $(".main-slider__item-descriptions").addClass("animations");
    $(".main-slider__item-text").addClass("animations");
    $(".main-slider__item-btn").addClass("animations");
  }, 200);
});

$(window).on('load resize', function () {
  if ($(window).width() < 1200) {
    $(".header__mobile-box").append($(".header__lang"));
    $(".header__mobile-box").append($(".header__nav"));
    $(".header__mobile-box").append($(".worldwide-btn"));
    $(".js-products").insertBefore($(".header__search-box"));
  } else {
    $(".header__right").append($(".header__lang"));
    $(".header__right").append($(".worldwide-btn"));
    $(".header__left").append($(".js-products"));
    $(".header__left").append($(".header__nav"));
  }
})


// WEBPACK FOOTER //
// app/scripts/index.js